import React, { useState, useEffect } from "react";
import { api } from "../api";
import JogoCard from "../componentes/JogoCard";
import "./Jogos.css";

export default function Jogos() {
  const [modo, setModo] = useState("grupos"); // "grupos" ou "geral"
  const [grupoSelecionado, setGrupoSelecionado] = useState(null);
  const [jogos, setJogos] = useState([]);
  const [gruposComJogos, setGruposComJogos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);

  // Carregar dados ao montar o componente
  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    try {
      setCarregando(true);
      setErro(null);

      // Carregar grupos com jogos
      const respGrupos = await api.get("/jogos/publico/grupos-com-jogos");
      setGruposComJogos(respGrupos.data);

      // Carregar todos os jogos
      const respJogos = await api.get("/jogos/publico/todos");
      setJogos(respJogos.data);

      // Selecionar primeiro grupo por padrão
      if (respGrupos.data.length > 0) {
        setGrupoSelecionado(respGrupos.data[0].grupo.id);
      }
    } catch (err) {
      console.error("Erro ao carregar jogos:", err);
      setErro("Erro ao carregar os jogos. Tente novamente.");
    } finally {
      setCarregando(false);
    }
  };

  const jogosSelecionados = () => {
    if (modo === "geral") {
      return jogos;
    } else {
      // Modo grupos
      const grupo = gruposComJogos.find((g) => g.grupo.id === grupoSelecionado);
      return grupo ? grupo.jogos : [];
    }
  };

  const handleModoChange = (novoModo) => {
    setModo(novoModo);
  };

  const handleGrupoChange = (grupoId) => {
    setGrupoSelecionado(grupoId);
  };

  if (carregando) {
    return (
      <div className="jogos-container">
        <div className="carregando">
          <div className="spinner"></div>
          <p>Carregando jogos...</p>
        </div>
      </div>
    );
  }

  if (erro) {
    return (
      <div className="jogos-container">
        <div className="erro">
          <p>{erro}</p>
          <button onClick={carregarDados} className="btn-tentar-novamente">
            Tentar Novamente
          </button>
        </div>
      </div>
    );
  }

  const jogosMostrados = jogosSelecionados();

  return (
    <div className="jogos-container">
      <div className="jogos-header">
        <h1>Fase de Grupos - Copa do Mundo 2026</h1>
        <p className="subtitulo">Faça seus palpites e concorra a prêmios!</p>
      </div>

      {/* Seletor de Modo */}
      <div className="modo-selector">
        <button
          className={`btn-modo ${modo === "grupos" ? "ativo" : ""}`}
          onClick={() => handleModoChange("grupos")}
        >
          <span className="icon">📋</span>
          Por Grupos
        </button>
        <button
          className={`btn-modo ${modo === "geral" ? "ativo" : ""}`}
          onClick={() => handleModoChange("geral")}
        >
          <span className="icon">📅</span>
          Cronológico
        </button>
      </div>

      {/* Filtro de Grupos (apenas no modo grupos) */}
      {modo === "grupos" && gruposComJogos.length > 0 && (
        <div className="grupo-selector">
          <div className="grupos-scroll">
            {gruposComJogos.map((g) => (
              <button
                key={g.grupo.id}
                className={`btn-grupo ${
                  grupoSelecionado === g.grupo.id ? "ativo" : ""
                }`}
                onClick={() => handleGrupoChange(g.grupo.id)}
              >
                {g.grupo.nome}
                <span className="qtd-jogos">{g.jogos.length}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Lista de Jogos */}
      <div className="jogos-lista">
        {jogosMostrados.length > 0 ? (
          <>
            <div className="jogos-info">
              <p>{jogosMostrados.length} jogo(s) encontrado(s)</p>
            </div>
            {jogosMostrados.map((jogo) => (
              <JogoCard key={jogo.id} jogo={jogo} />
            ))}
          </>
        ) : (
          <div className="sem-jogos">
            <p>Nenhum jogo encontrado para esta seleção.</p>
          </div>
        )}
      </div>
    </div>
  );
}
